import { Button } from "components/ui/button";
import Background from "./AnimatedBackground";

/* ---------------------- Foreground Content ---------------------- */
function Content() {
  return (
    <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
      {/* <div className="w-auto px-6 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm flex items-center justify-center gap-2 mb-4">
        <span className="text-[#ECE1CE]">✦</span>
        <span className="text-white/70 text-sm font-medium">
          Welcoming TikTok
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z"
            fill="#737373"
          />
        </svg>
        <span className="text-white/70 text-sm font-medium">
          to the BeigeOS
        </span>
      </div> */}

      <h1 className="text-5xl md:text-7xl font-semibold tracking-tight text-white mb-6 animate-in fade-in slide-in-from-bottom-6 duration-700 drop-shadow-2xl max-w-5xl mx-auto leading-[1.1]">
        The World's Most Seamless <br />
        <span className="text-golden">Production Platform</span>
      </h1>

      <p className="text-2xl text-white max-w-xl mx-auto mb-10 leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-700 delay-100 font-light">
        Connect your crew, equipment, and vision in one seamless dashboard.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-in fade-in slide-in-from-bottom-8 duration-700 delay-200 mb-16">
        <Button
          className="golden-button large-button w-52"
          // onClick={() => (window.location.href = "/login")}
        >
          Access Portal
        </Button>
        <Button
          className="glass-button large-button w-52"
          onClick={() => (window.location.href = "https://beige.app")}
        >
          Visit Beige.app
        </Button>
      </div>
      <div className="container mx-auto px-6 relative z-10 animate-in fade-in slide-in-from-bottom-12 duration-1000 delay-300">
        <div className="relative rounded-xl bg-[#0A0A0A] p-2 shadow-[0_0_50px_-12px_rgba(232,209,171,0.1)] border border-white/10 mx-auto max-w-6xl">
          <img
            src="/Beige X Memehouse3.png"
            alt="Dashboard Preview"
            className="rounded-lg w-full h-auto opacity-100"
          />
          {/* Reflection/Gloss */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-xl pointer-events-none" />
        </div>
      </div>
    </div>
  );
}

/* ---------------------- Main Export ---------------------- */
export default function HeroSection() {
  return (
    <section className="relative pt-32 lg:pt-48 overflow-hidden min-h-screen flex flex-col justify-center">
      <Background />
      <Content />
    </section>
  );
}
